import { Request, HttpResponse } from "./request"
import { BookingModel } from "@/app/models/booking.model"

const request = Request("/booking")

export async function getBookingPrice(
  booking: Pick<BookingModel, "id">,
): Promise<HttpResponse<BookingModel>> {
  return request()
    .method("GET")
    .url(`/${booking.id}/calculate`)
    .fire()
}
